/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdSpaceProps } from './type';

export const spaceDefaultProps: TdSpaceProps = { breakLine: false, direction: 'horizontal', size: 'medium' };
